import { ActionTooltip } from '@/_shared/components/ActionTooltip';
import { Button } from '@/_shared/components/ui/button';

interface Props {
  disabledReason: string | null;
  loading?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

/**
 * Primary Submit/Next for ask_question cards. `disabledReason` is the ONLY input: it drives both the
 * disabled state and the tooltip, so the button can never go dead without saying why (empty Other, no
 * selection, min not met). Disabled buttons get no pointer events, so the tooltip wraps a focusable span.
 */
export function QuestionSubmitButton({ disabledReason, loading, onClick, children }: Props): React.ReactElement {
  // While submitting, the reason is stale and the spinner + aria-busy already explain the state.
  const reason = loading ? null : disabledReason;
  return (
    <ActionTooltip show={reason != null} message={reason ?? ''} keepMounted>
      <Button variant="primary" disabled={disabledReason != null} loading={loading} onClick={onClick}>
        {children}
      </Button>
    </ActionTooltip>
  );
}
